import React, { useState } from "react";
import { KitProductModel } from "../../../Api/Models/product.model";
import ProductWithSizes from "./ProductWithSizes";
import { useTranslation } from "react-i18next";
import DotBreadcrumbs from "../../../Components/DotBreadcrumbs";
import {useUser} from "../../../Context/UserProvider";

interface ProductGroupProps {
  kitProducts: KitProductModel[];
  setKitProductGroupChoice(
    groupId: number,
    kitProductId: number,
    selectedVariationId: number | null
  ): void;
  skipProduct: CallableFunction;
  skipAll: CallableFunction;
  back: CallableFunction | null;
  currentStep: number;
  totalSteps: number;
}

const ProductGroup: React.FunctionComponent<ProductGroupProps> = ({
  kitProducts,
  setKitProductGroupChoice,
  skipProduct,
  skipAll,
  back,
    currentStep,
    totalSteps

}) => {
  const { t } = useTranslation();
  const { user } = useUser();

  const [selectedVariationalProduct, setSelectedVariationalProduct] =
    useState<KitProductModel | null>(null);

  const selectProduct = (productId: number) => {
    let product = kitProducts.find((x) => x.id === productId);
    if (product?.variations && product.variations.length > 0) {
      setSelectedVariationalProduct(product);
      return;
    }

    if (product?.optionalGroupId) {
      setKitProductGroupChoice(product.optionalGroupId, productId, null);
    }
  };

  const setKitProductVariation = (
    kitProductId: number,
    selectedVariationId: number
  ) => {
    if (kitProducts[0]?.optionalGroupId) {
      setKitProductGroupChoice(
        kitProducts[0].optionalGroupId,
        kitProductId,
        selectedVariationId
      );
      setSelectedVariationalProduct(null);
    }
  };

  const unselectVariationalProduct = () => {
    setSelectedVariationalProduct(null);
  };

  if (selectedVariationalProduct) {
    return (
      <ProductWithSizes
        kitProduct={selectedVariationalProduct}
        setKitProductVariation={setKitProductVariation}
        handleBack={unselectVariationalProduct}
        skipProduct={skipProduct}
        skipAll={skipAll}
        back={() => setSelectedVariationalProduct(null)}
        currentStep={currentStep}
        totalSteps={totalSteps}
        kitToAssignProducts={kitProducts}
      />
    );
  }

  return (
      <div>
        {kitProducts.map((product, index) => (
            <React.Fragment key={product.id}>
              <div className="product-list-card mb-4" onClick={() => selectProduct(product.id)}>
                <div className="relative">
                  <div className="flex items-center gap-2">
                    <div className="relative">
                      <div className="product-list-card__image">
                        <img src={product.image} alt={product.name} width="70px"/>
                      </div>
                    </div>

                    <div className="product-list-card__title">
                      <span>{product.name}</span>
                    </div>
                  </div>
                </div>
              </div>

              {index !== kitProducts.length - 1 && (
                  <p className="text-center mt-4 mb-4">Or</p>
              )}

            </React.Fragment>
        ))}

        <div className="mt-8 mb-8">
          <DotBreadcrumbs currentStep={currentStep} totalSteps={totalSteps}/>
        </div>

        <div className="flex gap-4 pb-4">
          <div className="flex-1">
            {back ? (
                <button
                    type="button"
                    className="button button--light"
                    onClick={() => back()}
                >
                  {t("Back")}
                </button>
            ) : (
                user?.skipAllGear ? (
                    <button
                        type="button"
                        className="button"
                        onClick={() => skipAll()}
                    >
                      {t("Skip all")}
                    </button>
                ) : null
            )}
          </div>
          <div className="flex-1">
            <button
                type="button"
                className="button"
                onClick={() => skipProduct(kitProducts[0].id)}
            >
              {t("Skip")}
            </button>
          </div>
        </div>
      </div>
  );
};

export default ProductGroup;
